import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Outward } from '../../classes/Outward';
import { ConstantsService } from '../../services/Constants/constants.service';
import { DataContextService } from '../../services/data-context.service';
import { StatusService } from '../status.service';


@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.less']
})
export class ProgressbarComponent implements OnInit {
  name = 'Angular';
  public status:any;
  id: any;
  EditOutwardDetails:Outward;
  
  private unsubscribe$ =new Subject<void>();
  service_URL: any;
  constructor(private service:StatusService,private route: ActivatedRoute,private _dataContextService: DataContextService,) {
    this.service_URL = ConstantsService;
    //this.status = service.getOrderStatus();
   }

  ngOnInit(): void {
this.id = this.route.snapshot.params['id'];
this.getDataById(this.id);

  }

getDataById(id: number) {
  let url =this.service_URL.OutwardDetails.GetDataById+'/'+id;
     
this._dataContextService.get<any>(url)
.pipe(takeUntil(this.unsubscribe$))
.subscribe(res=>{
  // console.log(res);
  this.EditOutwardDetails=res;
    //this.OutwardDetails=this.EditOutwardDetails;
this.status=this.EditOutwardDetails.status;
// console.log(this.status);
});
}
}
